<template>
	<div>
		<!-- Mobile Navigation side bar -->
		<mobile-nav-drawer v-if="$vuetify.breakpoint.mdAndDown" v-model="drawer" :user-type="userType"></mobile-nav-drawer>

		<!-- Top Navigation Bar -->
		<v-toolbar color="transparent" short tile elevation="0" class="mt-2" height="80px">
			<!-- Logo Wrapper -->
			<a :href="tenant.settings.brandUrl" target="_blank">
				<v-img :src="logoFileName" cover width="300px" />
			</a>

			<!-- Locum Tabs Wrapper -->
			<v-tabs v-if="$vuetify.breakpoint.mdAndUp && showMenuTabs" color="secondary" :hide-slider="true" active-class="text--secondary" centered class="ml-4">
				<v-tab :href="tenant.settings.brandUrl + '/faq'" target="_blank" router class="text-none font-weight-bold">FAQ</v-tab>
				<v-tab :href="tenant.settings.brandYoutubeUrl" target="_blank" router class="text-none font-weight-bold">Tutorials</v-tab>
				<v-tab :href="tenant.settings.brandUrl + '/contact'" target="_blank" router class="text-none font-weight-bold">Contact</v-tab>
			</v-tabs>
			<UnreadMessages
				v-if="unreadMessageCount > 0 && !showPractice && !isCompanyDashboardPage && $vuetify.breakpoint.mdAndUp && showMenuTabs"
				:unreadcount="unreadMessageCount"
				style="width: 5rem"
			/>
			<v-spacer></v-spacer>

			<!-- Pricing Dialog -->
			<v-btn
				v-if="showPractice && isCompanyDashboardPage && tenant.settings.pricing.show"
				class="mr-4 hidden-sm-and-down secondary--text font-weight-bold"
				depressed
				@click="openPricingDialog"
			>
				Pricing Options
			</v-btn>

			<v-btn v-if="showPractice && isCompanyDashboardPage" color="#5f6169" class="mr-4 hidden-sm-and-down white--text font-weight-bold" depressed @click="openRequestForm">
				Permanent Placements
			</v-btn>

			<!-- Locum Directory -->
			<v-btn v-if="showPractice && isCompanyDashboardPage" class="mr-4 hidden-sm-and-down primary--text font-weight-bold" depressed @click="openProfessionalDirectory">
				Locum Directory
			</v-btn>

			<!-- Inbox Messages -->
			<!-- For Mobile -->

			<UnreadMessages
				v-if="unreadMessageCount > 0 && showPractice && isCompanyDashboardPage && $vuetify.breakpoint.mdAndUp"
				:unreadcount="unreadMessageCount"
				style="width: 5rem"
			/>
			<v-spacer />
			<!-- Inbox Messages -->
			<!-- For Mobile -->
			<div>
				<UnreadMessages
					v-if="unreadMessageCount > 0 && showLocum && !isCompanyDashboardPage && !$vuetify.breakpoint.mdAndUp"
					:unreadcount="unreadMessageCount"
					class="mr-4 hidden-sm-and-down font-weight-bold white--text"
				/>
			</div>
			<!-- Wallet -->
			<div v-if="tenant.settings.wallet.show">
				<v-btn label color="secondary" class="mr-4 hidden-sm-and-down font-weight-bold white--text" @click="openWallet">
					<v-img :src="require('@/assets/images/LocumWallet logo_icon blue.png')" max-width="30" class="mr-2"></v-img>
					{{ getWallet.generalLabel }} R{{ getWallet.total }}
				</v-btn>
			</div>

			<div v-if="!tenant.settings.wallet.show && user.locale === 'company'">
				<v-btn color="secondary" class="mr-4 hidden-sm-and-down font-weight-bold white--text" @click="inviteLocum">Invite Locum</v-btn>
			</div>

			<!-- Practice avatar/menu -->
			<prac-nav-drawer-desktop
				v-if="showPractice"
				:custom-color="textColor"
				:profile-disabled="disableEditProfile"
				:account-disabled="disableAccount"
				:show-wallet="tenant.settings.wallet.show"
			/>

			<!-- Locum avatar/menu -->
			<locum-nav-drawer-desktop v-if="showLocum" :custom-color="textColor" :account-disabled="disableAccount" :profile-disabled="disableEditProfile" />

			<!-- Mobile Side Hamburger Menu Icon -->
			<v-app-bar-nav-icon v-if="$vuetify.breakpoint.mdAndDown" color="textColor" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
		</v-toolbar>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import store from '@/store';
import PracNavDrawerDesktop from '@/components/ui/dashboard/PracNavDrawerDesktop';
import LocumNavDrawerDesktop from '@/components/ui/dashboard/LocumNavDrawerDesktop';
import MobileNavDrawer from '@/components/ui/dashboard/MobileNavDrawer';
import UnreadMessages from '@/components/custom/UnreadMessages';
import { bus } from '@/main';
import { Tracking } from '@/utils';

export default {
	name: 'UserNavMenu',

	components: { MobileNavDrawer, LocumNavDrawerDesktop, PracNavDrawerDesktop, UnreadMessages },

	props: {
		bgColor: { type: String, default: '#ffffff' },
		textColor: { type: String, default: '#203843' },
		logoFileName: { type: String, default: 'logo.png' },
		userType: { type: String, default: 'PRACTICE' },
		showTabs: { type: Boolean, default: false },
		disableEditProfile: { type: Boolean, default: false },
		disableAccount: { type: Boolean, default: false },
	},

	data: () => ({
		drawer: false,
		showPractice: false,
		showLocum: false,
		showMenuTabs: false,
		companySelection: null,
		types: {
			USER_PRACTICE: 'PRACTICE',
			USER_LOCUM: 'LOCUM',
		},
		unreadMessageCount: 0,
		unreadChats: {},
		items: [{ title: 'Click Me' }, { title: 'Click Me' }, { title: 'Click Me' }, { title: 'Click Me 2' }],
	}),

	computed: {
		...mapGetters(['getWallet']),

		...mapGetters('tenant', ['tenant']),

		isCompanyDashboardPage() {
			return this.$route.name === 'PracticeDashboard';
		},

		company: () => store.getters.company,
		user() {
			return store.getters.user || {};
		},
	},

	async mounted() {
		// show all locum elements
		if (this.$props.userType === this.types.USER_LOCUM) {
			this.showPractice = false;
			this.showLocum = true;

			// show the menu tabs
			if (this.$props.showTabs || this.$props.showTabs == 'true') this.showMenuTabs = true;
			else this.showMenuTabs = false;
		}
		// show all practice elements
		else {
			this.companySelection = this.company;
			this.showPractice = true;
			this.showLocum = false;
		}
		await this.getUnreadMessageCount();
		bus.$on('refresh-total-unread-message-count', async () => {
			await this.getUnreadMessageCount();
		});
	},

	methods: {
		...mapActions('message', ['GetTotalUnreadCount']),
		openProfessionalDirectory() {
			bus.$emit('show-featured-popup');
			Tracking.track('Prac_LocumDirectory_Click');
		},

		openWallet() {
			bus.$emit('show-wallet-dialog');
		},

		openPricingDialog() {
			bus.$emit('show-pricing-dialog');
			Tracking.track('Pricing_Click');
		},

		openRequestForm() {
			bus.$emit('show-request-form');
			Tracking.track('Request_Click');
		},

		async getUnreadMessageCount() {
			const unreadCount = await this.GetTotalUnreadCount({
				receivedByID: this.user.locale === 'company' ? this.company.id : this.user.id,
			});
			this.unreadMessageCount = unreadCount;
		},

		dismissFeaturedLocums() {
			sessionStorage.setItem('featuredLocumsDismissed', true);
			bus.$emit('dismiss-featured-popup');
		},

		inviteLocum() {
			bus.$emit('show-invite-popup');
			this.dismissFeaturedLocums();
		},
	},
};
</script>

<style scoped>
.nav-company-selection {
	max-width: 300px;
}
</style>
